import { Component } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'

import { SalesPeriodsService } from '@/services/sales-periods.service'

import { TranslateService } from '@ngx-translate/core'

@UntilDestroy()
@Component({
  selector: 'pending-sales-periods',
  template: `
    <div class="mt-4">
      <sales-period-list
        [salesPeriods]="periods.pending$|async" 
        [title]="title"
        [hide]="'productCount,unsettledProductCount'"
        [approvalActions]="true"
      ></sales-period-list>
    </div>
  `
})
export class PendingSalesPeriodsViewComponent {

  constructor(
    public periods: SalesPeriodsService,
    private _translate: TranslateService,
  ) { }

  get title(): string {
    return this._translate.instant('pricing.title.pending')
  }
}
